import React from "react";

import { useAllUnitCategories, useRemoveUnitCategoryById } from "@api";
import { STRING } from "@constants";
import { GenericDetailsModal, Table, GenericDeleteDialog } from "@components";
import { UnitCategorySideBar } from "./UnitCategorySideBar";
import { useManageUnitCategory } from "./useManageUnitCategory";
import { useGetUnitCategory } from "./useGetUnitCategory";
import { getUnitCategoryDetails } from "./getUnitCategoryDetails";

const T = STRING.UNIT_CATEGORY_DETAILS;

export function UnitCategory() {
  const { data, loading, loadMore, hasMore } = useAllUnitCategories();
  const { removeUnitCategory } = useRemoveUnitCategoryById();

  const {
    handleCloseDeleteDialog,
    handleCloseDetailsModal,
    handlePressDeleteButton,
    handleRowClick,
    isDetailsModalOpen,
    isSideBarOpen,
    selectUnitCategoryToEdit,
    selectedUnitCategory,
    toggleSideBar,
    unitCategoryToDeleteId,
  } = useManageUnitCategory();

  const { columns } = useGetUnitCategory({
    onEdit: selectUnitCategoryToEdit,
    onDelete: handlePressDeleteButton,
  });

  const handleDelete = async () => {
    await removeUnitCategory(unitCategoryToDeleteId);
  };

  const { sections } = getUnitCategoryDetails(selectedUnitCategory);

  return (
    <div className="overflow-hidden">
      <GenericDeleteDialog
        visible={unitCategoryToDeleteId !== ""}
        onClose={handleCloseDeleteDialog}
        onDelete={handleDelete}
        texts={{
          header: T.CONFIRM_DELETE,
          warning: T.DELETE_WARNING,
          success: T.DELETE_SUCCESS,
          error: T.DELETE_ERROR,
        }}
      />
      <UnitCategorySideBar
        show={isSideBarOpen}
        editValues={selectedUnitCategory}
        onClose={toggleSideBar}
      />
      <GenericDetailsModal
        visible={isDetailsModalOpen}
        onHide={handleCloseDetailsModal}
        sections={sections}
        header={T.MODAL_HEADER}
        noDataText={T.NO_DATA}
      />
      <Table
        columns={columns}
        data={data}
        title="Unit Category"
        onAddNew={toggleSideBar}
        onRowClicked={handleRowClick}
        loading={loading}
        loadMore={hasMore ? loadMore : undefined}
      />
    </div>
  );
}
